import React, { Component } from "react";
import "../styles/Services.css";

export class Services extends Component {
  render() {
    return (
      <div>
        <h2 className="services-header">Our services</h2>
        <div className="service-categories">
          <div className="service-div">
            <h4>Gents</h4>
            <div className="services-list">
              <ul>
                <li>WEIGHT TRAINING</li>
                <li>CARDIO</li>
                <li>CORE EXERCISES</li>
                <li>AEROBICS</li>
                <li>NUTRITION AND DIETING</li>
                <li>KATABOX</li>
                <li>MARTIAL ART</li>
              </ul>
            </div>
            <div className="pricing">
              <h5>MONTHLY PLAN </h5>
              <p>1500/= </p>
              <h5>DAILY PLAN </h5>
              <p>100/= </p>
            </div>
          </div>
          <div className="service-div">
            <h4>Ladies</h4>
            <div className="services-list">
              <ul>
                <li>WEIGHT TRAINING</li>
                <li>STEPS AEROBICS</li>
                <li>CARDIO</li>
                <li>NUTRITION AND DIETING</li>
                <li>ZUMBA DANCE</li>
                <li>KATABOX</li>
              </ul>
              <div className="pricing">
                <h5>MONTHLY PLAN </h5>
                <p>2000/= </p>
                <h5>DAILY PLAN </h5>
                <p>100/= </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Services;
